import { makeStyles } from "@material-ui/core";
import { white, error } from "../../../constants/colors";

const useStyles = makeStyles(({ breakpoints: { down } }) => ({
  tab: {
    cursor: "pointer",
    background: "#F4F6F7",
    borderRadius: "10px",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    position: "relative",
    height: "64px",
    color: "#4A94EC",
    fontWeight: "bold",
    transition: "all 0.3s ease",
    [down("xs")]: {
      minWidth: "130px",

      "& p": {
        fontSize: "14px",
      },
    },
    "&:hover": {
      boxShadow: "0px 3px 14px rgba(0, 0, 0, 0.15)",
    },
  },
  active: {
    background: "rgb(74 148 236 / 100%)",
    color: "#fff",
    "&:hover": {
      boxShadow: "none",
    },
  },
  deleteIcon: {
    cursor: "pointer",
    position: "absolute",
    top: "10px",
    right: "10px",
    color: "red",
    [down("xs")]: {
      width: "18px",
      height: "18px",
      borderRadius: "50%",
      background: "rgb(74 148 236 / 100%)",
      right: "-9px",
      top: "auto",
      bottom: "calc(100% - 9px)",
    },
  },
  tabError: {
    height: "17px",
    width: "17px",
    borderRadius: "45px",
    background: error,
    position: "absolute",
    left: "15px",
    [down("xs")]: {
      top: "5px",
      left: "5px",
    },
    "& p": {
      fontFamily: "sbcBold",
      fontSize: "11px",
      color: white,
    },
  },
}));

export default useStyles;
